import React from "react";
import ReactDOM from "react-dom/client";
// import { RecoilRoot } from 'recoil';
import App from "./App";

import "./utilities/cssViewportHeight";
import "./utilities/cssHeaderHeight";
import "./index.css";

const container = document.getElementById("puregym_approot");
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    {/* <RecoilRoot> */}
    <App {...container.dataset} />
    {/* </RecoilRoot> */}
  </React.StrictMode>
);
